import themes from '@/themes.config';

export default function setupTheme() {
  const theme = themes[window.location.origin];
  if (theme) {
    console.log('theme', theme);

    document.body.classList.add(`custom-theme-${theme.name}`);
  }
}
